import React from 'react';
import axios from 'axios';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;

export default class Withdrawal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
        };

    }


    render() {
        // const panes = [
        //     {
        //         menuItem: 'Ispis sa smjera (studijskog programa)',
        //         render: () => (<Tab.Pane>
        //           <StudyProgramWithdrawal/>
        //           </Tab.Pane>)
        //     },
        //
        //     {
        //         menuItem: 'Ispis sa fakulteta',
        //         render: () => (<Tab.Pane>
        //           <OrgUnitWithdrawal/>
        //             </Tab.Pane>)
        //     },
        //
        //
        // ];

        return (<div>

        </div>);
    }
  }



// WEBPACK FOOTER //
// ./src/views/StudentService/FilterStudents/Withdrawal.js